import { React, PropTypes, reduxConnect } from '../lib/imports';

import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { Image, Spacing, SubmitButton, Text } from '../components';
import { setCompletedOnboarding } from './actions';
import { useCdnUrl } from './../app/context/config';
import { fireMessageEvent } from '../messenger/utils';
import { analyticActionMap } from '../analytics/utils';
import { flexCenter } from '../designTokens/styling/helpers';

const SuccessStyles = ({ theme }) => css`
  padding-top: ${theme.spacings.tera};
  margin-left: ${theme.spacings.peta};
  margin-right: ${theme.spacings.peta};
`;
const SuccessContainer = styled('div')(SuccessStyles);

const svgWrapperBaseStyles = () => css`
  ${flexCenter()};
`;

const CenteredSvgWrapper = styled('div')(svgWrapperBaseStyles);

const { clickedType, path, buttonType, makeYourPicks, onboarding } = analyticActionMap;

const Success = ({ headerText, blurbText, buttonText, logoUrl, handleOnboardingComplete, config }) => {
  const { platform, env } = config;
  const cdnUrl = useCdnUrl();
  return (
    <SuccessContainer>
      <Text lineHeight='22px' size='zetta' bold centered>
        {headerText}
      </Text>
      <Spacing paddingTop='giga' paddingBottom='exa'>
        <Text as='span' size='giga' noMargin centered>
          {blurbText}
        </Text>
      </Spacing>
      <CenteredSvgWrapper>
        <Image isSvg src={`${cdnUrl}${logoUrl}`} />
      </CenteredSvgWrapper>
      <Spacing paddingTop='yotta'>
        <SubmitButton
          variant='primary'
          text={buttonText}
          stretch
          onSelect={() => {
            fireMessageEvent({
              platform,
              env,
              title: clickedType,
              data: {
                path: path,
                modal: onboarding,
                element: buttonType,
                element_name: makeYourPicks,
              },
            });
            handleOnboardingComplete(config);
          }}
        />
      </Spacing>
    </SuccessContainer>
  );
};

Success.propTypes = {
  hasError: PropTypes.bool,
  errorText: PropTypes.string,
  headerText: PropTypes.string,
  blurbText: PropTypes.string,
  buttonText: PropTypes.string,
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => {
  const { strings, config } = state;

  return {
    headerText: strings['success/header/text'],
    blurbText: strings['success/blurb/text'],
    buttonText: strings['success/button/text'],
    logoUrl: strings['success/logo/src'],
    config,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleOnboardingComplete: (config) => dispatch(setCompletedOnboarding(config)),
  };
};

export default reduxConnect(mapStateToProps, mapDispatchToProps)(Success);
